var exports = {
  "nM": "ComparisonRow.module__row___MW9VY2",
  "N4": "ComparisonRow.module__feature___MW9VY2",
  "oo": "ComparisonRow.module__featureText___MW9VY2",
  "a7": "ComparisonRow.module__valuesContainer___MW9VY2",
  "dY": "ComparisonRow.module__restrictedValue___MW9VY2",
  "ge": "ComparisonRow.module__stockValue___MW9VY2",
};

module.exports = exports;
